import React, { FC, useCallback, useRef, useState } from 'react'
import Modal from 'styled-react-modal'

const AnimatedModal: FC<Props> = ({ renderContent, isOpen, onClose, backgroundProps }) => {
  const [isAnimated, setIsAnimated] = useState(false)
  const timer = useRef<NodeJS.Timeout | null>(null)

  const clearTimer = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }, [])

  const beforeCLose = useCallback(() => {
    clearTimer()
    return new Promise(resolve => {
      setIsAnimated(false)
      timer.current = setTimeout(resolve, 300)
    })
  }, [])

  const onAfterOpen = useCallback(() => {
    clearTimer()
    timer.current = setTimeout(() => {
      setIsAnimated(true)
    }, 0)
  }, [])

  return (
    <Modal
      onEscapeKeydown={onClose}
      backgroundProps={{ ...(backgroundProps || {}), opacity: Number(isAnimated) }}
      beforeClose={beforeCLose}
      isOpen={isOpen}
      onBackgroundClick={onClose}
      afterOpen={onAfterOpen}>
      {renderContent(isAnimated)}
    </Modal>
  )
}

export default AnimatedModal

interface Props {
  renderContent: (isActive: boolean) => JSX.Element
  isOpen: boolean
  onClose: () => void
  backgroundProps?: { background: string; centered?: boolean }
}
